import {
    GET_LIST_PATIENT_WAITING
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    list_patient_waiting: [],
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PATIENT_WAITING: {
            return {
                ...state,
                list_patient_waiting: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        default: return { ...state };
    }
}
